import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import Immutable from 'immutable';

const MyOffersMobile = ({ myOffers }) => {
  return (
    <Accordion accordion={ false }>
      {myOffers.valueSeq().map((myOffer) => (
        <AccordionItem key={ myOffer.get('id') }>
          <AccordionItemTitle>
            <div className='u-position-relative'>
              <div>
                <div className={ 'accordion-header__title' }>Offered Appt</div>
                <div className={ 'accordion-header__item' }>{convertDateToDayMonthYear(myOffer.getIn(['appointment', 'scheduledOn']))}{' '}
                  {convertTime(myOffer.getIn(['appointment', 'from']))}</div>
              </div>
              <div>
                <div className={ 'accordion-header__title' }>Office</div>
                <div className={ 'accordion-header__item' }>{myOffer.getIn(['appointment', 'office', 'name'])}</div>
              </div>
              <div>
                <div className={ 'accordion-header__title' }>Status</div>
                <div className={ 'accordion-header__item trade-post__trade-status--pending' }>Pending</div>
              </div>
            </div>
          </AccordionItemTitle>
        </AccordionItem>

      ))}
    </Accordion>

  );
};

MyOffersMobile.propTypes = {
  myOffers: PropTypes.instanceOf(Immutable.Map).isRequired
};

export default MyOffersMobile;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/offers/MyOffersMobile.jsx